












import { downloadUrlFromRemoteOrigin } from "@/lib/utility/downloadFileFunc";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IDownloadFile } from "./interface/download-file.interface";

@Component({
  components: {}
})
export default class FileDownload extends Vue {
  @Prop()
  downloadFiles!: IDownloadFile[];

  @Prop({ default: true })
  icon!: boolean;

  @Prop({ default: false })
  listItem!: boolean;

  get disabled() {
    if (this.downloadFiles.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  async download() {
    let overallSucess = true;
    for (const file of this.downloadFiles) {
      const success = await downloadUrlFromRemoteOrigin(file.url, file.filename);
      if (!success) {
        overallSucess = false;
      }
    }
    if (overallSucess) {
      Vue.$toast.success("Download erfolgreich.");
    } else {
      Vue.$toast.error("Fehler beim Download. Es konnten nicht alle Dateien heruntergeladen werden.");
    }
  }
}
